import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const DummyContainer = () => import('@/containers/DefaultDummyContainer')

const SearchBar = () => import('@/views/auftraege/searchbar')
const Auftraege = () => import('@/views/auftraege/Auftraege')
const Auftraege_All = () => import('@/views/auftraege/Auftraege_All')
const Auftraege_Abgelehnt = () => import('@/views/auftraege/Auftraege_Abgelehnt')
const Auftraege_Offen = () => import('@/views/auftraege/Auftraege_Offen')
const Auftraege_Fertig = () => import('@/views/auftraege/Auftraege_Fertig')
const Auftraege_Rechnung = () => import('@/views/auftraege/Auftraege_Rechnung')
const Auftraege_Freigabe_Offen = () => import('@/views/auftraege/Auftraege_Freigabe_Offen')
const Auftraege_Freigabe_Geschlossen = () => import('@/views/auftraege/Auftraege_Freigabe_Geschlossen')
const Auftraege_Sammel = () => import('@/views/auftraege/Auftrag_Sammelrechnung')
//const Auftrag = () => import('@/views/auftraege/auftrag/auftrag')
const AuftragRouter = () => import('@/views/auftraege/auftrag/AuftragRouter.vue')
const Test = () => import('@/views/auftraege/create/test')
const Test2 = () => import('@/views/pages/LocalStorage')

const AnfragenAll = () => import('@/views/anfragen_new/AnfragenAll')
const AnfragenOffen = () => import('@/views/anfragen_new/AnfragenOpen')
const AnfragenInWork = () => import('@/views/anfragen_new/AnfragenInWork')
const AnfragenFinished = () => import('@/views/anfragen_new/AnfragenFinished')
const AnfragenAbgelehnt = () => import('@/views/anfragen_new/AnfragenDecliend')

const AufgabenOffen = () => import('@/views/aufgaben/aufgaben_offen')
const AufgabenAbgelehnt = () => import('@/views/aufgaben/aufgaben_abgelehnt')
const AufgabenFertig = () => import('@/views/aufgaben/aufgaben_fertig')
const AufgabenAlle = () => import('@/views/aufgaben/aufgaben_alle')

const GeoReferencing = () => import('@/views/geo_referencing/geo_referencing')

const Inbox = () => import('@/views/inbox/Inbox')


const Auftraege_All_M = () => import('@/views/aufgaben_from_me/Auftraege_All')
const IframeTest = () => import('@/views/pages/iframe_test.vue')
const Auftraege_Abgelehnt_M = () => import('@/views/aufgaben_from_me/Auftraege_Abgelehnt')
const Auftraege_Offen_M = () => import('@/views/aufgaben_from_me/Auftraege_Offen')
const Auftraege_Fertig_M = () => import('@/views/aufgaben_from_me/Auftraege_Fertig')
const Auftraege_Rechnung_M = () => import('@/views/aufgaben_from_me/Auftraege_Rechnung')
const Auftraege_Sammel_M = () => import('@/views/aufgaben_from_me/Auftrag_Sammelrechnung')

const AufagbenVerwaltung = () => import('@/views/aufgaben/aufgaben_verwaltung_router')

const Messaging = () => import('@/views/messaging/messaging.vue')
const MessagingRooms = () => import('@/views/messaging/messaging_rooms.vue')
const MessagingSingleRoom = () => import('@/views/messaging/messaging_single_room.vue')

const BisInbox = () => import('@/views/inbox/BisInbox.vue')

const Contacts = () => import('@/views/messaging/contacts.vue')
const Stamm = () => import('@/views/stammauftrag/Stammauftraege.vue')
const CreateTaskAndroid = () => import('@/views/auftraege/create/AndroidRouter.vue')
const TaskLists = () => import('@/views/planning_lists/PlanningLists.vue')
const ImportStreets = () => import('@/views/stammdaten/streets_test.vue')
const TaskSeriesVerwaltung = () => import('@/views/task_series/TaskSeriesVerwaltung.vue')
const TaskSeries = () => import('@/views/task_series/TaskSeries.vue')
const PredefinedTourVerwaltung = () => import('@/views/predefined_tours/PredefinedTourVerwaltung.vue')
const PredefinedTour = () => import('@/views/predefined_tours/PedefinedTour.vue')

const Planning = () => import('@/views/planning/Planning.vue')

const CreateTaskSeries = () => import('@/views/auftraege/create_series/CreateSeriesStepper.vue')
const TaskExecutionView = () => import('@/views/predefined_tours/TaskExecutionView.vue')


Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      //redirect: '/auftraege/alle',
      redirect: '/inbox/messages',
      name: 'Auftragsbuch',
      component: DefaultContainer,
      children: [
        {
          path: 'auftraege',
          redirect: '/auftraege/alle',
          name: 'Aufträge',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "alle",
              name: 'Alle',
              component: Auftraege_All
            },
            {
              path: "offen",
              name: 'Offen',
              component: Auftraege_Offen
            },
            {
              path: "fertig",
              name: 'Fertig',
              component: Auftraege_Fertig
            },
            {
              path: "rechnung",
              name: 'Rechnung',
              component: Auftraege_Rechnung
            },
            {
              path: "abgelehnt",
              name: 'Abgelehnt',
              component: Auftraege_Abgelehnt
            },
            {
              path: "rechnung_sammel",
              name: 'Sammelrechnung',
              component: Auftraege_Sammel
            },
            {
              path: "freigabe/offen",
              name: 'Freigabe/Offen',
              component: Auftraege_Freigabe_Offen
            },
            {
              path: "freigabe/abgelehnt",
              name: 'Freigabe/Abgelehnt',
              component: Auftraege_Freigabe_Geschlossen
            },
            {
              path: 'auftrag/:id',
              component: AuftragRouter,
            },
            {
              path: 'task_series/:id',
              component: TaskSeries,
            },
            {
              path: 'predefined_tour/:id',
              component: PredefinedTour,
            }
          ],
        },

        {
          path: 'aufgaben_m',
          redirect: '/aufgaben_m/alle',
          name: 'Gestellte Aufgaben',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "alle",
              name: 'Alle',
              component: Auftraege_All_M
            },
            {
              path: "offen",
              name: 'Offen',
              component: Auftraege_Offen_M
            },
            {
              path: "fertig",
              name: 'Fertig',
              component: Auftraege_Fertig_M
            },
            {
              path: "rechnung",
              name: 'Rechnung',
              component: Auftraege_Rechnung_M
            },
            {
              path: "abgelehnt",
              name: 'Abgelehnt',
              component: Auftraege_Abgelehnt_M
            },
            {
              path: "rechnung_sammel",
              name: 'Sammelrechnung',
              component: Auftraege_Sammel_M
            },
          ],
        },

        {
          path: 'bauhof',
          redirect: '/bauhof/posteingang',
          name: 'Bauhof',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "aufgabenverwaltung",
              name: 'Aufgabenverwaltung',
              component: AufagbenVerwaltung
            },
            {
              path: "posteingang",
              name: 'Posteingang',
              component: BisInbox
            },
          ],
        },

        {
          path: 'anfragen',
          redirect: '/anfragen/offen',
          name: 'Anfragen',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "alle",
              name: 'Alle',
              component: AnfragenAll
            },
            {
              path: "offen",
              name: 'Offen',
              component: AnfragenOffen
            },
            {
              path: "in_bearbeitung",
              name: 'In Bearbeitung',
              component: AnfragenInWork
            },
            {
              path: "fertig",
              name: 'Fertig',
              component: AnfragenFinished
            },
            {
              path: "abgelehnt",
              name: 'Abgelehnt',
              component: AnfragenAbgelehnt
            },
          ],
        },
        {
          path: 'geo_referencing',
          redirect: '/geo_referencing/reference',
          name: 'Georeferenzierungen',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "reference",
              name: 'Georeferenzierung',
              component: GeoReferencing
            }
          ],
        },
        {
          path: 'inbox',
          redirect: '/inbox/messages',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "messages",
              name: 'Posteingang',
              component: Inbox
            },
          ]
        },
        {
          path: 'planning',
          redirect: '/planning/planning',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "planning",
              name: 'Planung',
              component: Planning
            },
          ]
        },
        {
          path: 'stamm',
          redirect: '/stamm/auftraege',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "auftraege",
              name: 'Stammauftraege',
              component: Stamm
            },
          ]
        },
        {
          path: 'chats',
          redirect: '/chats/chat',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "chat",
              name: 'Chats',
              component: Messaging
            },
            {
              path: "rooms",
              name: 'Rooms',
              component: MessagingRooms
            },
            {
              path: "rooms/:id",
              name: 'Room',
              component: MessagingSingleRoom
            },
            {
              path: "contacts",
              name: 'Contacts',
              component: Contacts
            },
          ]
        },
        {
          path: 'aufgaben',
          redirect: '/aufgaben/alle',
          name: 'Aufgaben',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "alle",
              name: 'Alle',
              component: AufgabenAlle
            },
            {
              path: "offen",
              name: 'Offen',
              component: AufgabenOffen
            },
            {
              path: "verwaltung",
              name: 'Aufgabenverwaltung',
              component: AufagbenVerwaltung
            },
            {
              path: "abgelehnt",
              name: 'Abgelehnt',
              component: AufgabenAbgelehnt
            },
            {
              path: "task_series",
              name: 'Aufgabenserien',
              component: TaskSeriesVerwaltung
            },
            {
              path: "predefined_tours",
              name: 'Vorgefertigte Touren',
              component: PredefinedTourVerwaltung
            },
            {
              path: "predefined_tour_execution/:id",
              name: 'Touren Ausführungen',
              component: TaskExecutionView
            },
            {
              path: "liste",
              name: 'Aufgaben Listen',
              component: TaskLists
            },
          ],
        },
        {
          path: 'touren_pro',
          redirect: '/touren_pro/import/streets',
          name: 'Touren Pro',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "import/streets",
              name: 'Strassen Import',
              component: ImportStreets
            },
          ],
        },

        /*{
          path: 'tests',
          redirect: '/tests/iframe',
          name: 'Tests',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "iframe",
              name: 'iframe',
              component: IframeTest
            },
          ],
        },*/

        {
          path: 'create',
          name: 'Erteilen',
          component: Test
        },
        {
          path: 'e_create',
          name: 'Erteilen',
          component: Test
        },
        {
          path: 's_create',
          name: 'Erteilen',
          component: CreateTaskSeries
        },
        {
          path: 'create_android',
          name: 'Erteilen',
          component: CreateTaskAndroid
        },
      ]
    },
    {
      path: '/start_page',
      component: DummyContainer,
    },
    {
      path: '/pages',
      redirect: '/pages/test2',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'test2',
          name: 'Test2',
          component: Test2
        }
      ]
    }
  ]
})
